/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface HtmlCellProps {
  children: string
  style?: React.CSSProperties
}

const HtmlCell: React.FC<HtmlCellProps> = ({ children, style }) => {
  return (
    <div
      style={style}
      dangerouslySetInnerHTML={{
        __html: children
      }}
    />
  )
}

export default HtmlCell
